import angular from 'angular';
import {
  ssDialogService,
  loaderService,
  emDataService,
  emSharedModelService
} from 'app/services';
import {
  alerts,
  actionIcon
} from 'app/components/global';
import validator, { name as validatorName } from './messages/asset-type-unique-name.validator.directive';
import controller from './add-asset-type-dialog.controller';
import template from './add-asset-type-dialog.html';
import messageTpl from './messages/asset-type-name.messages.html';

class dialogService {
  getOptions($event, { functionId, assetType }) {
    return {
      controller,
      controllerAs: 'addAssetTypeDialogVM',
      locals: {
        functionId,
        assetType
      },
      bindToController: true,
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.enterpriseModeling.addAssetTypeDialog', [
  alerts,
  actionIcon,
  ssDialogService,
  loaderService,
  emDataService,
  emSharedModelService
])
  .service('addAssetTypeDialog', dialogService)
  .directive(validatorName, validator)
  .run(($templateCache) => {
    $templateCache.put('asset-type-name.messages.html', messageTpl);
  })
  .name;

console.log('app.components.advisory.enterpriseModeling.addAssetTypeDialog created');
